import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/vendor`; 

export const vendorListService = { 
      getSupplierList: async function () {
        return axios.get(`${GATEWAY_URL}/get_vendor_list`, { 
        })
            .then((response) => {
                return response.data;
            });
    },

     updateProductPortfolio: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/save_vendor_list`, values)
            .then((response) => {
                return response.data;
            });
    },
}
